import { render, staticRenderFns } from "./report-charts.vue?vue&type=template&id=515ecf26&scoped=true"
import script from "./report-charts.vue?vue&type=script&lang=js"
export * from "./report-charts.vue?vue&type=script&lang=js"
import style0 from "./report-charts.vue?vue&type=style&index=0&id=515ecf26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515ecf26",
  null
  
)

export default component.exports